import { create } from 'zustand';

interface useAuthStore {
  permissions: Record<string, boolean>;
  system: boolean;
  adminId: string;
  apiKey: string;
  update: ({
    permissions,
    system,
    adminId,
    apiKey
  }: {
    permissions: string[];
    system: boolean;
    adminId: string;
    apiKey: string;
  }) => void;
}

export const useAuth = create<useAuthStore>((set) => ({
  permissions: {},
  system: false,
  adminId: '',
  apiKey: '',
  update: (params) =>
    set(
      {
        ...params,
        permissions: params.permissions.reduce((p, l) => {
          p[l] = true;
          return p;
        }, {} as any)
      },
      false
    )
}));
